'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 9.53674e-07C0 9.53674e-07 0.895431 9.53674e-07 2 9.53674e-07H28C28 9.53674e-07 28 0.895432 28 2V20C28 20 27.1046 20 26 20H2C0.895431 20 0 20 0 20V9.53674e-07Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 9.53674e-07H28V20H0V9.53674e-07Z", fill: "#E81B26" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9998 13.3334C15.8408 13.3334 17.3332 11.841 17.3332 10C17.3332 8.15907 15.8408 6.66669 13.9998 6.66669C12.1589 6.66669 10.6665 8.15907 10.6665 10C10.6665 11.841 12.1589 13.3334 13.9998 13.3334Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.2082 7.27932C10.4095 6.99925 10.641 6.74239 10.8981 6.51353L4.99998 0L0 9.53674e-07L10.2082 7.27932Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.8981 13.4864C10.641 13.2576 10.4095 13.0007 10.2082 12.7207L0 20H4.99998L10.8981 13.4864Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.0846 14.5769L12 20H16L14.9154 14.5769C14.6194 14.6358 14.3134 14.6666 14.0001 14.6666C13.6868 14.6666 13.3807 14.6358 13.0846 14.5769Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.792 12.7208C17.5907 13.0009 17.3591 13.2577 17.102 13.4866L23 20H28L17.792 12.7208Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.37979 10.66C9.34926 10.4444 9.33347 10.224 9.33347 9.99998C9.33347 9.77594 9.34926 9.55558 9.37978 9.33997L0 8V12L9.37979 10.66Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.0846 5.42308L12 9.53674e-07H16L14.9154 5.42303C14.6194 5.36418 14.3134 5.33331 14.0001 5.33331C13.6868 5.33331 13.3807 5.3642 13.0846 5.42308Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.6205 9.33993C18.651 9.55556 18.6668 9.77592 18.6668 9.99998C18.6668 10.224 18.651 10.4444 18.6205 10.6601L28 12V8L18.6205 9.33993Z",
          fill: "#FFE94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.792 7.27919C17.5907 6.99911 17.3591 6.74226 17.1021 6.5134L23 1.33514e-05L28 9.53674e-07L17.792 7.27919Z",
          fill: "#FFE94F"
        }
      )
    ]
  }
);
const VpFlagMkAsset = forwardRef(FlagMkAsset);

export { VpFlagMkAsset as default };
